import Request from './request'

const BankPayment  = {
  getBankPaymentList(params, callback, bad_answer) {
    Request.get('bank-payments', params).then(callback).catch(bad_answer)
  },
  getBankPayment(id, callback) {
    Request.get('bank-payments/' + id).then(callback).catch(this.bad_answer)
  },
  importBankPayments(params) {
    return Request.sendfile('bank-payments/import', params)
  },
  getBankPaymentImportHistory(callback, bad_answer) {
    Request.get('bank-payments/import-history').then(callback).catch(bad_answer)
  },
}

export default BankPayment
